import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RegisterModalOutlet } from "src/apps/shared/RegisterModalOutlet";
import { useAuth } from "src/auth";

import { useSessionStorage } from "src/hooks/useSessionStorage";
import { Loading } from "./Loading";

export const RequireAuth = () => {
  const { token, isAuthenticated, isAccountRegistered, isLoadingUser, loginFromToken, isLoggingIn } =
    useAuth();
  const { data: registerLater } = useSessionStorage("register-later");

  const location = useLocation();

  useEffect(() => {
    if (token && !isAuthenticated) {
      loginFromToken(token);
    }
  }, [token, isAuthenticated]);

  if (!isAccountRegistered && !isLoadingUser && token && registerLater !== "true") {
    return <RegisterModalOutlet />;
  }

  const loading = isLoadingUser || isLoggingIn;

  if (loading) {
    return <Loading />;
  }

  if (!isAuthenticated && !token) {
    return <Navigate state={{ from: location }} to="/login" />;
  }

  return <Outlet />;
};
